import { getMessaging, getToken } from "firebase/messaging";
import app from "./firebaseKeys";
import { getFromStorage, setToStorage } from "../helpers/storage";
import { STORAGE_KEYS } from "../constants/storageKeys";

const firebaseCloudMessaging = {
  // eslint-disable-next-line consistent-return
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const swRegistration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );
        const fcm_token = await getToken(messaging, {
          vapidKey:
            "BAGBYrt9bKnZblbbByIiOH_g_2kavhjriUfO73Amfgzv7bC1tuqwiuPth0xNF4V89Ki7Uce9E8GUXU2qnR7oAho",
          serviceWorkerRegistration: swRegistration,
        });

        if (fcm_token) {
          setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      } else {
        console.log("Notification permission not granted.");
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };
